// for payroll summary
export const PAYROLL_SUMMARY = "payroll_info";
export const PAYROLL_SUMMARY_SUCCESS = "payroll_info_success";
export const PAYROLL_SUMMARY_FAILURE = "payroll_info_failure";
